<!-- Workspace Templates -->
<ng-template #documentWorkspace>
  <fl-document-viewer
    #docViewer="fl-document-viewer"
    class="component-selectable"
    [attr.data-id]="documentService.document.id"
    [attr.data-selectable-type]="'document'"
    [document]="documentService.document"
    [renderPageObjects]="true"
  ></fl-document-viewer>

  <div class="draggable-fields-container" *ngIf="!formLegacyService.form || (formLegacyService.form && formLegacyService.editable)">
    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.Text" name="text" (mousedown)="fieldButtonSelected('text')">
      <i class="material-icons">text_format</i>
      Textbox
    </button>
    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.Checkbox" name="checkbox" (mousedown)="fieldButtonSelected('checkbox')">
      <i class="material-icons">check_box</i>
      Single Checkbox
    </button>
    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.CheckboxSpecial" name="checkbox_special" (mousedown)="fieldButtonSelected('checkbox_special')">
      <i class="material-icons">check_box</i>
      <i class="material-icons">check_box</i>
      True/False Group
    </button>
    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.Signature" name="signature" (mousedown)="fieldButtonSelected('signature')">
      <i class="material-icons">gesture</i>
      Signature
    </button>

    <div class="divider"></div>

    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.FixedText" name="fixed_text" (mousedown)="fieldButtonSelected('fixed_text')">
      <i class="material-icons">format_shapes</i>
      Fixed Text
    </button>
    <button mat-button color="primary" class="draggable-field iconic" [attr.data-page-object-type]="pageObjectType.Date" name="date" (mousedown)="fieldButtonSelected('date')">
      <i class="material-icons">calendar_today</i>
      Date Label
    </button>
  </div>
</ng-template>

<ng-template #formWorkspace>
  <section class="form-view">
    <ul class="sections-list">
      @for(section of formLegacyService.form.sections; track section) {
        <li [class.selected]="this.editorState.selectedItem.id === section.id">
          @if (section.visibility_key) {
            <i class="material-icons conditional-visibility" matTooltip="Section is conditionally visible">
              visibility_off
            </i>
          } @else {
            <i class="material-icons conditional-visibility-always" matTooltip="Section is always visible">
              visibility
            </i>
          }
          <a (click)="scrollToElement(section.id)">
            {{ section.title }}
          </a>
        </li>
      }
    </ul>

    <fl-builder
      (onRemoveElement)="removeElement($event)"
      (onRemoveSection)="removeSection($event)"
      [attr.data-id]="formLegacyService.form.id"
      [attr.data-selectable-type]="'form'"
      class="component-selectable"
    ></fl-builder>
  </section>
</ng-template>

<ng-template #rtdWorkspace>
  <fl-richtext-editor
    class="component-selectable"
    [advancedRichTextEditor]="advancedRichTextEditor"
    [attr.data-selectable-type]="'rtd'"
    [form]="formLegacyService.form">
  </fl-richtext-editor>
</ng-template>
<!-- End Workspace Templates -->

<div class="toolbar" *ngIf="{ isDeleting: documentService.deletionState[0] === DocumentFieldDeletionStatus.Deleting } as vm">
  <nav
    mat-tab-nav-bar
    (click)="displayExitConfirmationModal()"
    [tabPanel]="tabPanel"
    *ngIf="formLegacyService.form"
  >
    <ng-container *ngIf="documentService.document || formLegacyService.form.rtd">
      <a mat-tab-link [active]="workspaceType === WorkspaceType.Form" (click)="setWorkspace(WorkspaceType.Form)" [disabled]="vm.isDeleting">
        Form Editor
      </a>
    </ng-container>

    <ng-container *ngIf="documentService.document">
      <a mat-tab-link [active]="workspaceType === WorkspaceType.Document" (click)="setWorkspace(WorkspaceType.Document)">
        Document
      </a>
    </ng-container>

    <ng-container *ngIf="formLegacyService.form.rtd">
      <a mat-tab-link [active]="!advancedRichTextEditor && workspaceType === WorkspaceType.Rtd" (click)="setRichTextEditorView('basic')" [disabled]="vm.isDeleting">
        Basic Editor
      </a>

      <a mat-tab-link [active]="advancedRichTextEditor"  (click)="setRichTextEditorView('advanced')" [disabled]="vm.isDeleting">
        Advanced Editor
      </a>
    </ng-container>
  </nav>

  <div class="badges" *ngIf="formLegacyService.form">
    @if(formLegacyService.form.global) {
      <span class="badge global">
        <span class="icon" inlineSVG="/assets/icons/attention.svg"></span>
        Global Form
      </span>
    }

    <span class="badge published" *ngIf="formLegacyService.form?.active">
      Published
    </span>

    <span class="badge unpublished" *ngIf="!formLegacyService.form?.active">
      Not Published
    </span>

    <span class="badge locked" *ngIf="!formLegacyService.form.unlocked_by_user?.id">
      <span class="icon" inlineSVG="/assets/icons/lock.svg"></span>
      Locked
    </span>

    @if (formLegacyService.form.unlocked_by_user) {
      <span class="badge locked" *ngIf="formLegacyService.form.unlocked_by_user?.id !== (user$ | async).id">
        <span class="icon" inlineSVG="/assets/icons/lock.svg"></span>
        Locked
      </span>

      <span class="badge editable" *ngIf="formLegacyService.form.unlocked_by_user?.id === (user$ | async).id">
        <span class="icon" inlineSVG="/assets/icons/edit.svg"></span>
        Editable
      </span>
    }
  </div>

  <p class="form-saved-at" *ngIf="formLegacyService.form">Last saved at: {{this.formUpdatedAt$ | async | momentDate}}</p>

  <div class="actions">
    <div class="session-counter investment-profile-list" *ngIf="activeSessions$ | async as activeSessions">
      <div class="session-container">

        <ng-container *ngIf="formLegacyService.form.unlocked_by_user">
          <span>Locked by</span>

          <ul class="profile-members" style="margin-right:1.5rem">
            <li
              data-testid="initials"
              matTooltip="{{formLegacyService.form.unlocked_by_user.email}}"
            >{{formLegacyService.form.unlocked_by_user.initials}}</li>
          </ul>
        </ng-container>

        <span data-testid="session-counter">{{ activeSessions }} Viewer{{ activeSessions > 1 ? 's' : '' }}</span>

        <ul class="profile-members">
          <li
            data-testid="initials"
            matTooltip="{{member.value.email}}"
            *ngFor="let member of membersOnline$ | async | keyvalue"
          >{{member.value.name}}</li>
        </ul>

      </div>
    </div>

    <div class="action-button">
      <a mat-button color="primary" (click)="openInfoModal()" [disabled]="vm.isDeleting">Info</a>
    </div>

  </div>
</div>

<div cdkScrollable class="workspace-outlet flex-cell-full-height">
  <mat-tab-nav-panel #tabPanel>
    <ng-container *ngTemplateOutlet="currentWorkspace"></ng-container>
  </mat-tab-nav-panel>
</div>
